import { createHOC } from 'vue-hoc';

import withUser from '~lib/common/hoc/withUser';
import fetchOrgData from '~lib/common/utils/fetchOrgData';

import AssignmentSharingTable from './AssignmentSharingTable';

const options = {
  name: 'AssignmentSharingTableContainer',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      state: {
        loading: false,
        orgData: {
          users: [],
          groups: [],
        },
        error: null,
      },
    };
  },
  async created() {
    this.state.loading = true;
    fetchOrgData(this.user).then(
      result => {
        this.state.orgData = result;
      },
      error => {
        console.log(error);
      },
    ).then(() => {
        this.state.loading = false;
    });
  },
  methods: {
  },
};

const renderWith = {
  props: {
    loading() {
      return this.state.loading;
    },
    users() {
      return this.state.orgData.users;
    },
    groups() {
      return this.state.orgData.groups;
    },
    error() {
      return this.state.error;
    },
  },
  listeners: {
  },
};

const AssignmentSharingTableContainer = createHOC(AssignmentSharingTable, options, renderWith);
export default withUser()(AssignmentSharingTableContainer);
